import gql from 'graphql-tag';

export default gql`
  fragment telLogDownloadFragment on TelLogDownload {
    id
    uuid
    file
    createdAt
  }
`;
